<template>
  <div>
    <v-row
      v-for="(meal, idx) in meals.orders"
      :key="idx"
      v-if="meal.shift == shift.label && meal.quantity > 0"
    >
      <v-col cols="auto">
        <v-img
          class="order-details-img"
          width="100"
          height="100"
          :src="
            meals.image
              ? conf.apiUrlBase +
                '/gallery/' +
                meals.image.restaurant_id +
                '/medium/' +
                meals.image.name
              : './media/img/no-image.webp'
          "
        >
          <template v-slot:placeholder>
            <v-row class="fill-height ma-0" align="center" justify="center">
              <v-progress-circular
                indeterminate
                color="grey lighten-5"
              ></v-progress-circular>
            </v-row>
          </template>
        </v-img>
      </v-col>
      <v-col class="px-0 mx-0">
        <v-card elevation="0" class="pa-1">
          <v-card-title style="padding: 0 15px">
            <h3 class="order-details-meal-name">
              {{ $t(meals.name) }}
            </h3>
          </v-card-title>
          <v-card-text class="mb-4">
            <v-row no-gutters>
              <v-col>
                <v-row no-gutters>
                  <template v-for="(eat, i) in meals.foods">
                    <v-col cols="12" class="font-weight-bold pt-2">
                      <v-row no-gutters justify="space-between">
                        <h3 class="order-details-food-name">
                          {{ $t(eat.name) }}
                        </h3>
                      </v-row>
                    </v-col>
                    <v-col cols="12">{{ $t(eat.description) }}</v-col>
                  </template>
                </v-row>
              </v-col>
              <v-col cols="auto">
                <div class="order-details-qty-box">
                  <v-text-field
                    class="ukinuti_liniju"
                    v-model="meal.quantity"
                    type="number"
                    prepend-icon="mdi-minus"
                    min="0"
                    hide-details
                    dense
                    append-icon="mdi-plus"
                    readonly
                    @click:prepend="
                      meal.quantity > 0 && meal.quantity--;
                      reserveMore(meal.quantity, meal, meals, shift.label);
                    "
                    @click:append="
                      meal.quantity++;
                      reserveMore(meal.quantity, meal, meals, shift.label);
                    "
                  ></v-text-field>
                </div>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import conf from "@/config";
export default {
  name: "OrderDetailsFoodCard",
  props: {
    meals: Object,
    shift: Object,
    reserveMore: Function,
  },
  data() {
    return {
      conf,
    };
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/styles/_variables.scss";

/* You can reuse the same styles as in OrderDetailsDialog.vue */
.order-details-img {
  border-radius: 12px;
}

.order-details-meal-name {
  font-family: "Poppins", Helvetica, sans-serif !important;
  font-weight: 700;
  color: #2c2c2c;
  font-size: 16px;
  line-height: 20px;
}

.order-details-food-name {
  font-family: "Poppins", Helvetica, sans-serif !important;
  font-weight: 700;
  color: rgba(0, 0, 0, 0.4);
  font-size: 13px;
}

.order-details-qty-box {
  width: 140px;
  border: 1px solid rgba(0, 0, 0, 0.12);
  padding: 5px;
  border-radius: 12px;
}

.ukinuti_liniju {
  .v-input__slot::before {
    border-style: none !important;
    border-width: 0 !important;
  }

  .v-text-field__slot input {
    text-align: center !important;
  }

  .v-input__icon--prepend,
  .v-input__icon--append {
    padding: 0 !important;
    width: 35px !important;
    height: 35px !important;
    background: rgba(98, 52, 5, 0.02) !important;
    border: 1px solid #dee0e3;
    border-radius: 6px;

    button {
      color: $primary-color;
    }
  }

  .v-input__icon--prepend {
    margin-top: -5px;
    margin-right: 7px;
  }
}
</style>
